/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class AccountSelfCreationSettings extends PageStringSection {
    button_save_label: string = "Labels.lbl_Save";
    formItem_emailAddress_label: string = "Labels.lbl_EmailAddress";
    formItem_city_label: string = "Labels.lbl_AddressCity";
    formItem_country_label: string = "Labels.lbl_AddressCountry";
    formItem_department_label: string = "Labels.lbl_UserDepartment";
    formItem_firstName_label: string = "Labels.lbl_UserFirstName";
    formItem_formConfiguration_hidden_option: string = "Labels.lbl_Hidden";
    formItem_formConfiguration_optional_option: string = "Labels.lbl_Optional";
    formItem_formConfiguration_required_option: string = "Labels.lbl_Required";
    formItem_lastName_label: string = "Labels.lbl_UserLastName";
    formItem_location_label: string = "Labels.lbl_Location";
    formItem_password_label: string = "Labels.lbl_Password";
    formItem_phoneNumber_label: string = "Labels.lbl_PhoneNumber";
    formItem_practiceArea_label: string = "Labels.lbl_UserPracticeArea";
    formItem_profile_label: string = "Labels.lbl_UserProfile";
    formItem_state_label: string = "Labels.lbl_AddressState";
    formItem_street1_label: string = "Labels.lbl_AddressStreet1";
    formItem_street2_label: string = "Labels.lbl_AddressStreet2";
    formItem_title_label: string = "Labels.lbl_UserTitle";
    formItem_username_label: string = "Labels.lbl_LoginUserName";
    formItem_userProfile_label: string = "Labels.lbl_UserProfile";
    formItem_userCustomString1_label: string = "Labels.lbl_UserCustomString1";
    formItem_userCustomString2_label: string = "Labels.lbl_UserCustomString2";
    formItem_userCustomString3_label: string = "Labels.lbl_UserCustomString3";
    formItem_userCustomString4_label: string = "Labels.lbl_UserCustomString4";
    formItem_userCustomString5_label: string = "Labels.lbl_UserCustomString5";
    formItem_userCustomString6_label: string = "Labels.lbl_UserCustomString6";
    formItem_zipCode_label: string = "Labels.lbl_AddressZip";
    heading_formConfiguration: string = "Labels.lbl_FormConfiguration";
    radio_approvalRequestEmail_doNotSend_option: string = "Messages.msg_EmailSendToDoNotSend";
    radio_approvalRequestEmail_label: string = "Labels.lbl_ApprovalRequestEmail";
    radio_approvalRequestEmail_SystemAdministrator_option: string = "Messages.msg_EmailSendToAdministrator";
    radio_approvalRequestEmail_SpecificEmailAddress_option: string = "Messages.msg_EmailSendToSpecific";
    switch_accountSelfCreation_ariaLabel: string = "Messages.msg_EnableAccountSelfCreation";
    switch_accountSelfCreation_label: string = "Messages.msg_EnableAccountSelfCreation";
    switch_approvalRequired_ariaLabel: string = "Labels.lbl_ApprovalRequired";
    switch_approvalRequired_label: string = "Labels.lbl_ApprovalRequired";
}
